import React, { useCallback, useState } from 'react';

import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';

import { DeleteReturnLine } from './DeleteReturnLine';
import { EditReturnLine } from './EditReturnLine';
import { ReturnOrderLine } from '../../orders/types';
import { useReturnStore } from '../../store';

// Register this component for debug tracking
debug.registerComponent('ReturnLineExtras');

const ReturnLineExtras = ({ record }: { record: ReturnOrderLine }) => {
  debug.trackRender('ReturnLineExtras');
  const { addReturn, deleteReturnLine } = useReturnStore();
  debug.log('ReturnLineExtras', `Rendering for nart: ${record?.nart}`);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleOpenModal = useCallback((isOpen: boolean) => {
    setIsOpenModal(isOpen);
  }, []);

  return (
    <>
      <EditReturnLine
        record={record}
        onAddReturn={addReturn}
        isOpenModal={isOpenModal}
        setIsOpenModal={handleOpenModal}
      />
      <DeleteReturnLine record={record} onDeleteReturn={deleteReturnLine} />
    </>
  );
};

export { ReturnLineExtras };

// Mark this component as initialized
debug.markInitialized('ReturnLineExtras');
